import { createOperationSlice, GenericOperationState } from '@repo/core'
import { ConvenienceTestQuestionnaire } from '@repo/user-types'

const initialState: GenericOperationState<ConvenienceTestQuestionnaire | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const {
  actions: convenienceTestQuestionnaireActions,
  reducer: convenienceTestQuestionnaireReducer,
} = createOperationSlice({
  name: '@users/convenienceTest/questionnaire',
  initialState,
  reducers: {},
})
